import React, { useEffect, useRef, useState } from 'react';

function ResponsiveShadow({ children, className = '', style = {} }) {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
  const [maxHeight, setMaxHeight] = useState('calc(100vh - 130px)');
  const containerRef = useRef(null);

  useEffect(() => {
    function handleResize() {
      setIsSmallScreen(window.innerWidth <= 768);
      computeMaxHeight();
    }

    function computeMaxHeight() {
      try {
        const el = containerRef.current;
        const header = document.querySelector('.navbar');
        const footer = document.querySelector('footer.footer') || document.querySelector('footer');
        const elTop = el ? el.getBoundingClientRect().top : 80;
        const headerBottom = header ? header.getBoundingClientRect().bottom : 80;
        const footerTop = footer ? footer.getBoundingClientRect().top : window.innerHeight - 40;
        // Mantém a folga inferior igual à folga superior (entre navbar e janela)
        const topGap = Math.max(0, elTop - headerBottom);
        const bottomGap = Math.max(20, topGap);
        const available = Math.floor(footerTop - elTop - bottomGap);
        setMaxHeight(`${Math.max(160, available)}px`);
      } catch (e) {
        setMaxHeight('calc(100vh - 130px)');
      }
    }

    computeMaxHeight();
    window.addEventListener('resize', handleResize);
    const mo = new MutationObserver(computeMaxHeight);
    mo.observe(document.body, { childList: true, subtree: true, attributes: true });
    return () => {
      window.removeEventListener('resize', handleResize);
      mo.disconnect();
    };
  }, []);

  const defaultStyle = {
    backgroundColor: 'rgba(255, 255, 255, 0.92)',
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    minHeight: 0,
    maxHeight: isSmallScreen ? 'auto' : maxHeight,
    overflow: 'hidden',
    borderRadius: '0.75rem',
    ...style,
  };

  const defaultClassName = `mt-0 mb-0 p-0 ${className}`;

  return (
    <div
      ref={containerRef}
      className={`${defaultClassName} shadow-lg rounded-3`}
      style={defaultStyle}
    >
      {children}
    </div>
  );
}

export default ResponsiveShadow;